'use strict'

import Vue from 'vue'
import AppConfig from '@/config'
import { EventBus } from "@/modules/event-bus"
//import VueCookies from 'vue-cookies'

const state = {
  token: null,
  userNo: null,
  loginId: null,
  userName: null,
  partnerNo: null,
  partnerName: null,
  roleLevel: null,
  userTypeCode: null,
}

const getters = {
  getToken(state) {
    return state.token
  },
  getUserNo(state) {
    return state.userNo
  },
  getLoginId(state) {
    return state.loginId
  },
  getUserName(state) {
    return state.userName
  },
  getPartnerNo(state) {
    return state.partnerNo
  },
  getPartnerName(state) {
    return state.partnerName
  },
  getRoleLevel(state) {
    return state.roleLevel
  },
  getUserTypeCode(state) {
    return state.userTypeCode
  }
}

const mutations = {
  setToken(state, { token }) {
    state.token = token
  },
  setUserNo(state, { userNo }) {
    state.userNo = userNo
  },
  setLoginId(state, { loginId }) {
    state.loginId = loginId
  },
  setUserName(state, { userName }) {
    state.userName = userName
  },
  setPartnerNo(state, { partnerNo }) {
    state.partnerNo = partnerNo
  },
  setPartnerName(state, { partnerName }) {
    state.partnerName = partnerName
  },
  setRoleLevel(state, { roleLevel }) {
    state.roleLevel = roleLevel
  },
  setUserTypeCode(state, { userTypeCode }) {
    state.userTypeCode = userTypeCode
  }
}

const actions = {
  login({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      Vue.httpClient
        .post(AppConfig.HTTP_CONFIG.authURL + '/login', params)
        .then(response => {
          if (response.data.result) {
            commit('setToken', { token: response.headers['x-auth-token'] })
            commit('setUserNo', { userNo: response.data.result.userNo })
            commit('setLoginId', { loginId: response.data.result.loginId })
            commit('setUserName', { userName: response.data.result.userName })
            commit('setPartnerNo', { partnerNo: response.data.result.partnerNo })
            commit('setPartnerName', { partnerName: response.data.result.partnerName })
            commit('setRoleLevel', { roleLevel: response.data.result.roleLevel })
            commit('setUserTypeCode', { userTypeCode: response.data.result.userTypeCode })

            Vue.httpClient.defaults.headers.common['x-auth-token'] = response.headers['x-auth-token'];
            Vue.$sessionStorage.set('xAuthToken', response.headers['x-auth-token'])
          }

          resolve(response.data.result.initPasswordYn)
        })
        .catch(e => reject(e))
    })
  },
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      Vue.httpClient
        .post(AppConfig.HTTP_CONFIG.authURL + '/logout', {})
        .then(response => {
          if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
            commit('setToken', { token: null })
            commit('setUserNo', { userNo: null })
            commit('setLoginId', { loginId: null })
            commit('setUserName', { userName: null })
            commit('setPartnerNo', { partnerNo: null })
            commit('setPartnerName', { partnerName: null })
            commit('setRoleLevel', { roleLevel: null })
            commit('setUserTypeCode', { userTypeCode: null })

            Vue.httpClient.defaults.headers.common['x-auth-token'] = null;
            Vue.$sessionStorage.clear();

            EventBus.$emit("event-logout");
          }
          resolve()
        })
        .catch(e => reject(e))
    })
  },
  isLogin({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.token) {
        resolve()
      } else {
        Vue.httpClient.defaults.headers.common['x-auth-token'] = Vue.$sessionStorage.get('xAuthToken')

        Vue.httpClient
          .post(AppConfig.HTTP_CONFIG.authURL + '/login/check', {})
          .then(response => {
            if (response.data.result && response.data.result.isLogin) {
              commit('setToken', { token: response.headers['x-auth-token'] })
              commit('setUserNo', { userNo: response.data.result.userNo })
              commit('setLoginId', { loginId: response.data.result.loginId })
              commit('setUserName', { userName: response.data.result.userName })
              commit('setPartnerNo', { partnerNo: response.data.result.partnerNo })
              commit('setPartnerName', { partnerName: response.data.result.partnerName })
              commit('setRoleLevel', { roleLevel: response.data.result.roleLevel })
              commit('setUserTypeCode', { userTypeCd: response.data.result.userTypeCode })

              Vue.httpClient.defaults.headers.common['x-auth-token'] = response.headers['x-auth-token'];
              Vue.$sessionStorage.set('xAuthToken', response.headers['x-auth-token'])

              resolve()
            } else {
              reject()
            }
          })
          .catch(e => reject(e))
      }
    })
      .then(function () {
        return true
      }).catch(function () {
        return false
      });

  },
  refreshLogin({ commit, state }) {
    return new Promise((resolve, reject) => {
      Vue.httpClient
        .post(AppConfig.HTTP_CONFIG.authURL + '/login/check', {})
        .then(response => {
          if (response.data.result && response.data.result.isLogin) {
            commit('setToken', { token: response.headers['x-auth-token'] })
            commit('setUserNo', { userNo: response.data.result.userNo })
            commit('setLoginId', { loginId: response.data.result.loginId })
            commit('setUserName', { userName: response.data.result.userName })
            commit('setPartnerNo', { partnerNo: response.data.result.partnerNo })
            commit('setPartnerName', { partnerName: response.data.result.partnerName })
            commit('setRoleLevel', { roleLevel: response.data.result.roleLevel })
            commit('setUserTypeCode', { userTypeCd: response.data.result.userTypeCode })

            Vue.httpClient.defaults.headers.common['x-auth-token'] = response.headers['x-auth-token'];
            Vue.$sessionStorage.set('xAuthToken', response.headers['x-auth-token'])

            resolve()
          } else {
            reject()
          }
        })
        .catch(e => reject(e))
    })
      .then(function () {
        return true
      }).catch(function () {
        return false
      });
  },
  aiLogin({ commit, state }, params) {
    return new Promise((resolve, reject) => {
    //   Vue.httpClient
    //     .post(AppConfig.HTTP_CONFIG.authURL + '/login', params)
    //     .then(response => {
    //       if (response.data.result) {
    //         commit('setToken', { token: response.headers['x-auth-token'] })
    //         commit('setUserNo', { userNo: response.data.result.userNo })
    //         commit('setLoginId', { loginId: response.data.result.loginId })
    //         commit('setUserName', { userName: response.data.result.userName })
    //         commit('setPartnerNo', { partnerNo: response.data.result.partnerNo })
    //         commit('setPartnerName', { partnerName: response.data.result.partnerName })
    //         commit('setRoleLevel', { roleLevel: response.data.result.roleLevel })
    //         commit('setUserTypeCode', { userTypeCode: response.data.result.userTypeCode })

    //         Vue.httpClient.defaults.headers.common['x-auth-token'] = response.headers['x-auth-token'];
    //         Vue.$sessionStorage.set('xAuthToken', response.headers['x-auth-token'])
    //       }

    //       resolve(response.data.result.initPasswordYn)
    //     })
    //     .catch(e => reject(e))
    })
  },
  aiLogout({ commit, state }) {
    return new Promise((resolve, reject) => {
       Vue.httpClient
         .post(AppConfig.HTTP_CONFIG.authURL + '/m/ai/aiLogout', {})
         .then(response => {
           if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
             commit('setToken', { token: null })
             commit('setUserNo', { userNo: null })
    //         commit('setLoginId', { loginId: null })
    //         commit('setUserName', { userName: null })
    //         commit('setPartnerNo', { partnerNo: null })
    //         commit('setPartnerName', { partnerName: null })
    //         commit('setRoleLevel', { roleLevel: null })
    //         commit('setUserTypeCode', { userTypeCode: null })

             Vue.httpClient.defaults.headers.common['x-auth-token'] = null;
             Vue.$sessionStorage.clear();
             //Vue.use(VueCookies);
             //VueCookies.keys().forEach(cookie => VueCookies.remove(cookie));

             //window.$store.dispatch('LatestMenu/clearLatestMenu');

             EventBus.$emit("ai-event-logout");
           }
           resolve()
         })
         .catch(e => reject(e))
    })
  },
  aiIsLogin({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.token) {
        resolve()
      } else {
        Vue.httpClient.defaults.headers.common['x-auth-token'] = Vue.$sessionStorage.get('xAuthToken')

        Vue.httpClient
          .post(AppConfig.HTTP_CONFIG.authURL + '/m/ai/login/aiMobileCheck', {})
          .then(response => {
            if (response.data.result && response.data.result.isLogin) {
              commit('setToken', { token: response.headers['x-auth-token'] })
	            commit('setUserNo', { userNo: response.data.result.userNo })
	            Vue.httpClient.defaults.headers.common['x-auth-token'] = response.headers['x-auth-token'];
	            Vue.$sessionStorage.set('xAuthToken', response.headers['x-auth-token'])

            //   commit('setToken', { token: response.headers['x-auth-token'] })
            //   commit('setUserNo', { userNo: response.data.result.userNo })
            //   commit('setLoginId', { loginId: response.data.result.loginId })
            //   commit('setUserName', { userName: response.data.result.userName })
            //   commit('setPartnerNo', { partnerNo: response.data.result.partnerNo })
            //   commit('setPartnerName', { partnerName: response.data.result.partnerName })
            //   commit('setRoleLevel', { roleLevel: response.data.result.roleLevel })
            //   commit('setUserTypeCode', { userTypeCd: response.data.result.userTypeCode })

            //   Vue.httpClient.defaults.headers.common['x-auth-token'] = response.headers['x-auth-token'];
            //   Vue.$sessionStorage.set('xAuthToken', response.headers['x-auth-token'])

              resolve()
            } else {
              reject()
            }
          })
          .catch(e => reject(e))
      }
    })
      .then(function () {
        return true
      }).catch(function () {
        return false
      });

  },
  aiRefreshLogin({ commit, state }) {
	    return new Promise((resolve, reject) => {
	      Vue.httpClient
	        .post(AppConfig.HTTP_CONFIG.authURL + '/m/ai/login/aiMobileCheck', {})
	        .then(response => {
	          if (response.data.result && response.data.result.isLogin) {
	            commit('setToken', { token: response.headers['x-auth-token'] })
	            commit('setUserNo', { userNo: response.data.result.userNo })
	            /*
	            commit('setLoginId', { loginId: response.data.result.loginId })
	            commit('setUserName', { userName: response.data.result.userName })
	            commit('setPartnerNo', { partnerNo: response.data.result.partnerNo })
	            commit('setPartnerName', { partnerName: response.data.result.partnerName })
	            commit('setRoleLevel', { roleLevel: response.data.result.roleLevel })
	            commit('setUserTypeCode', { userTypeCd: response.data.result.userTypeCode })
	             */
	            Vue.httpClient.defaults.headers.common['x-auth-token'] = response.headers['x-auth-token'];
	            Vue.$sessionStorage.set('xAuthToken', response.headers['x-auth-token'])

	            resolve()
	          } else {
	            reject()
	          }
	        })
	        .catch(e => reject(e))
	    })
	      .then(function () {
	        return true
	      }).catch(function () {
	        return false
	      });
	  },
  guestLogin({ commit, state }, params) {
	    return new Promise((resolve, reject) => {
	      Vue.httpClient
	        .post(AppConfig.HTTP_CONFIG.authURL + '/guestLogin', params)
	        .then(response => {
	          if (response.data.result) {
	        	/*
	            commit('setToken', { token: response.headers['x-auth-token'] })
	            commit('setUserNo', { userNo: response.data.result.userNo })
	            commit('setLoginId', { loginId: response.data.result.loginId })
	            commit('setUserName', { userName: response.data.result.userName })
	            commit('setPartnerNo', { partnerNo: response.data.result.partnerNo })
	            commit('setPartnerName', { partnerName: response.data.result.partnerName })
	            commit('setRoleLevel', { roleLevel: response.data.result.roleLevel })
	            commit('setUserTypeCode', { userTypeCode: response.data.result.userTypeCode })
	        	*/

	        	commit('setUserTypeCode', { userTypeCode: response.data.result.userTypeCode })

	            Vue.httpClient.defaults.headers.common['x-auth-token'] = response.headers['x-auth-token'];
	            Vue.$sessionStorage.set('xAuthToken', response.headers['x-auth-token'])


	          }
	          resolve(true)

	          //resolve(true)
	        })
	        .catch(e => reject(e))
	    })
	  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/stores/modules/Login.js